// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"b733808b","146":"2cd785df","160":"dc5e6bfe","169":"ac19f89a","227":"9ec52e1d","317":"9981bd59","349":"7dfdb7d8","364":"778db8fe","585":"741405cf","599":"ce0e8a5f","629":"2b07f175","793":"fa5e0979","852":"1599e08a","896":"4166fc90","931":"b595b997"}[chunkId] + ".chunk.js";
};